import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "QM9P8G",
    defaultMessage: "Assign Attribute",
    description: "dialog header",
  },
  searchInputLabel: {
    id: "fP9FXB",
    defaultMessage: "Search Attributes",
    description: "input label",
  },
  searchInputPlaceholder: {
    id: "auxEP1",
    defaultMessage: "Search by attribute name",
    description: "input placeholder",
  },
  noMembersFound: {
    id: "PkjQS6",
    defaultMessage: "No results found",
    description: "description",
  },
  assignButton: {
    id: "Nv/toB",
    defaultMessage: "Assign and save",
    description: "button",
  },
});
